<template>

  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <div v-if="active" class="pure-g">
          <div class="pure-u-1-2"><h3 class="responsive">{{step}}. Delivery address</h3></div>
          <div class="pure-u-1-2 text-right">
            <button v-if="active && canEdit" v-on:click="editOverride" class="link-lookalike">Close</button>
          </div>

          <span class="pure-u-1 subtext-lg italics margin-top-10"> We suggest shipping your beer to a commercial address. Someone 21+ must be there to sign for your beer. </span>
          <div class="pure-u-1 spacing-20"></div>


          <Loading v-if="loading"/>

          <form class="pure-u-1 pure-form pure-form-stacked" v-if="!loading" @submit.prevent="submit">
            <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label>Address type</label></div>
            <div class="pure-u-1 pure-u-sm-1-2">
              <AddressType v-model="address.address_type"></AddressType>
            </div>

            <fieldset>
              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="name">Name</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="text" id="name" class="pure-input-1"
                                                         v-model="address.name">
                <ValidationErrors :errors="validationErrors.name"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="line1">Address</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="text" id="line1" class="pure-input-1"
                                                         v-model="address.line1">
                <ValidationErrors :errors="validationErrors.line1"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4"><label for="line2"></label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="text" id="line2" class="pure-input-1"
                                                         v-model="address.line2"
                                                         placeholder="For an apartment, Suite, etc (optional)"></div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="city">City</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="text" id="city" class="pure-input-1"
                                                         v-model="address.city">
                <ValidationErrors :errors="validationErrors.city"/>
              </div>


              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="state_token">State</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><select id="state_token" class="pure-input-1"
                                                          v-model="user.state_token">
                <option v-for="option in stateList" v-bind:value="option.value">
                  {{ option.text }}
                </option>
              </select>
                <ValidationErrors :errors="validationErrors.state_token"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="zip">Zip</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="tel" id="zip" class="pure-input-1" v-model="address.zip">
                <ValidationErrors :errors="validationErrors.zip"/>
              </div>


              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="phone">Phone</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="tel" id="phone" class="pure-input-1"
                                                         v-model="address.phone">
                <ValidationErrors :errors="validationErrors.phone"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4"></div>
              <div class="pure-u-1 pure-u-sm-1-2">
                <button type="submit" class="pure-button pure-button-primary block padding-10" >
                  {{buttonText}}
                </button>
                <p class="text-red" v-if="error">
                  {{ error }}
                  <ValidationErrors :errors="validationErrors.general"/>
                </p>
              </div>
            </fieldset>
          </form>
        </div>

        <div v-else class="pure-g">
          <div class="pure-u-4-5"><h3 class="responsive">{{step}}. Delivery address</h3></div>
          <div class="pure-u-1-5 text-right">
            <button v-if="canEdit" v-on:click="edit" class="link-lookalike">Change</button>
          </div>

          <ul v-if="address.name" class="summary pure-u-1">
            <li class="pure-u-1">
              <div class="hidden-sm pure-u-sm-1-5 text-right ">Name</div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">{{ address.name }}</div>
            </li>
            <li class="pure-u-1">
              <div class="hidden-sm pure-u-sm-1-5 text-right ">Phone</div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">{{ formatPhoneNumber }}</div>
            </li>
            <li class="pure-u-1">
              <div class="hidden-sm pure-u-sm-1-5 text-right">Address</div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">{{ address.line1 }}</div>
            </li>
            <li v-if="address.line2" class="pure-u-1">
              <div class="hidden-sm pure-u-sm-1-5"></div>
              <div class="pure-u-3-5 padding-left-10">{{ address.line2 }}</div>
            </li>
            <li class="pure-u-1">
              <div class="hidden-sm pure-u-sm-1-5"></div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">{{ address.city }} {{ convertStateToken }} {{ address.zip }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import user from '../../lib/user';
  import AddressType from './AddressType';
  import Loading from '../helpers/Loading';
  import ValidationErrors from '../helpers/ValidationErrors';
  import addresses from '../../lib/addresses';
  import store from '../../lib/store';

  export default {
    name: 'AddressCreator',
    components: { AddressType, Loading, ValidationErrors },
    props: ['active', 'step'],
    data() {
      return {
        loading: false,
        isBusy: false,
        canEdit: false,
        validationErrors: {},
        error: '',
        defaultErrorMsg: 'Something went wrong, please try again.',
        address: {
          id: '',
          name: '',
          line1: '',
          line2: '',
          city: '',
          zip: '',
          phone: '',
          address_type: 'Residential',
        },
        user: {
          id: '',
          fname: '',
          lname: '',
          state_token: '',
        },
        stateList: [
          { value: 7788, text: 'Alaska' },
          { value: 7789, text: 'Alabama' },
          { value: 7790, text: 'Arkansas' },
          { value: 7791, text: 'Arizona' },
          { value: 7792, text: 'California' },
          { value: 7793, text: 'Colorado' },
          { value: 7794, text: 'Connecticut' },
          { value: 7795, text: 'District of Columbia' },
          { value: 7796, text: 'Delaware' },
          { value: 7797, text: 'Florida' },
          { value: 7798, text: 'Georgia' },
          { value: 7799, text: 'Hawaii' },
          { value: 7800, text: 'Iowa' },
          { value: 7801, text: 'Idaho' },
          { value: 7802, text: 'Illinois' },
          { value: 7803, text: 'Indiana' },
          { value: 7804, text: 'Kansas' },
          { value: 7805, text: 'Kentucky' },
          { value: 7806, text: 'Louisiana' },
          { value: 7807, text: 'Massachusetts' },
          { value: 7808, text: 'Maryland' },
          { value: 7809, text: 'Maine' },
          { value: 7810, text: 'Michigan' },
          { value: 7811, text: 'Minnesota' },
          { value: 7812, text: 'Missouri' },
          { value: 7813, text: 'Mississippi' },
          { value: 7814, text: 'Montana' },
          { value: 7815, text: 'North Carolina' },
          { value: 7816, text: 'North Dakota' },
          { value: 7817, text: 'Nebraska' },
          { value: 7818, text: 'New Hampshire' },
          { value: 7819, text: 'New Jersey' },
          { value: 7820, text: 'New Mexico' },
          { value: 7821, text: 'Nevada' },
          { value: 7822, text: 'New York' },
          { value: 7823, text: 'Ohio' },
          { value: 7824, text: 'Oklahoma' },
          { value: 7825, text: 'Oregon' },
          { value: 7826, text: 'Pennsylvania' },
          { value: 7827, text: 'Rhode Island' },
          { value: 7828, text: 'South Carolina' },
          { value: 7829, text: 'South Dakota' },
          { value: 7830, text: 'Tennessee' },
          { value: 7831, text: 'Texas' },
          { value: 7832, text: 'Utah' },
          { value: 7833, text: 'Virginia' },
          { value: 7834, text: 'Vermont' },
          { value: 7835, text: 'Washington' },
          { value: 7836, text: 'Wisconsin' },
          { value: 7837, text: 'West Virginia' },
          { value: 7838, text: 'Wyoming' },
        ],
      };
    },
    watch: {
      active() {
        if (store.get('authToken')) {
          this.getUserInfo();
          this.getAllAddresses();
        }
        if (this.active && store.get('subscription')) {
          /* global ga */
          ga('send', 'pageview', `/${store.get('subscription')}/AddressCreator`);
        }
      },
    },
    methods: {
      setErrors(errors) {
        const res = Object.assign({}, errors);
        if (res.city_id) {
          res.city = ['Cannot find this city, is it spelled correctly?'];
        }
        this.validationErrors = res;
      },
      clearErrors() {
        this.validationErrors = '';
      },
      createAddress() {
        this.isBusy = true;
        addresses.create(this.address, (err, res) => {
          this.isBusy = false;
          if (err) {
            this.parseErrors(res);
          } else {
            this.canEdit = true;
            this.clearErrors();
            this.$emit('success');
          }
        });
      },
      updateAddress() {
        this.isBusy = true;
        addresses.update(this.address, (err, res) => {
          this.isBusy = false;
          if (err) {
            this.parseErrors(res);
          } else {
            this.canEdit = true;
            this.clearErrors();
            this.editOverride();
          }
        });
      },
      getAllAddresses() {
        this.loading = true;
        const that = this;
        addresses.all((err, res) => {
          this.loading = false;
          if (err) {
            this.error = this.defaultErrorMsg;
          } else if (res.body && res.body.addresses) {
            const defaultAddress = res.body.addresses.find(this.findDefault);
            if (defaultAddress) {
              that.address.id = defaultAddress.id;
              that.address.name = defaultAddress.name;
              that.address.line1 = defaultAddress.line1;
              that.address.line2 = defaultAddress.line2;
              that.address.city = defaultAddress.city;
              that.address.zip = defaultAddress.zip;
              that.address.phone = defaultAddress.phone;
              that.address.address_type = defaultAddress.address_type;

              if (!that.canEdit) {
                that.canEdit = true;
                that.clearErrors();
                that.$emit('success');
              }
            }
          }
        });
      },
      updateUser(cb) {
        this.isBusy = true;
        const body = {
          id: this.user.id,
          state_token: this.user.state_token,
        };
        user.update(body, (err, res) => {
          this.isBusy = false;
          if (err) {
            this.parseErrors(res);
          }
          if (cb) {
            cb();
          }
        });
      },
      getUserInfo() {
        this.loading = true;
        user.all((err, res) => {
          this.loading = false;
          if (err) {
            this.parseErrors(res);
          } else if (res.body.user) {
            this.user.id = res.body.user.id;
            this.user.fname = res.body.user.fname;
            this.user.lname = res.body.user.lname;
            this.user.state_token = res.body.user.state_id;
            if (this.address.name === '') {
              this.address.name = `${this.user.fname} ${this.user.lname}`;
            }
          }
        });
      },
      submit() {
        this.error = '';
        if (this.canEdit) {
          const that = this;
          const cb = function () {
            that.updateAddress();
          };
          this.updateUser(cb);
        } else {
          const that = this;
          const cb = function () {
            that.createAddress();
          };
          this.updateUser(cb);
        }
      },
      edit() {
        this.$emit('editView', 'AddressCreator');
      },
      editOverride() {
        this.$emit('editDone');
      },
      parseErrors(res) {
        if (res && res.statusCode === 422) {
          this.setErrors(res.body.errors);
        } else {
          this.error = this.defaultErrorMsg;
        }
      },
      findDefault(item) {
        return item.is_default;
      },
    },
    computed: {
      convertStateToken() {
        const match = this.stateList.find(state => state.value === this.user.state_token);
        return match ? match.text : '';
      },
      formatPhoneNumber() {
        const phoneToken = this.address.phone.replace(' |(|)|-', '').split('').join('');
        if (phoneToken.length === 10) {
          return `(${phoneToken.substring(0, 3)}) ${phoneToken.substring(3, 6)}-${phoneToken.substring(6, 10)}`;
        }
        return this.user.phone;
      },
      buttonText() {
        if (this.canEdit) {
          return 'Update and continue';
        }
        return 'Continue to payment';
      },
    },
  };
</script>

<style scoped>

  label {
    margin-top: 10px;
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// AddressCreator.vue?7e041c99